export const resultsStyle = {
  display: "block",
  fontStyle: "italic",
  color: "#777",
  fontSize: 15,
  lineHeight: "18px"
};
